import { capitaliseFirst } from "@./string-utils";
import { PRICING_PLAN_QUANTITY } from "@/constants/pricing";
import { PricingPlan } from "@/primary-models";

const formatTitle = (pricingPlan: PricingPlan) => `${capitaliseFirst(pricingPlan, true)} plan`;

export const MEAL_PLAN_STANDARD = {
  _uid: PricingPlan.STANDARD,
  title: formatTitle(PricingPlan.STANDARD),
  value: PricingPlan.STANDARD,
  component: "select_option",
  advanced_options: {
    secondaryText: `${PRICING_PLAN_QUANTITY[PricingPlan.STANDARD]} days worth of food every 28 days`,
    tertiaryText: "£2.09/day",
  },
} as const;

export const MEAL_PLAN_SAVER = {
  _uid: PricingPlan.SAVER,
  title: formatTitle(PricingPlan.SAVER),
  value: PricingPlan.SAVER,
  component: "select_option",
  advanced_options: {
    secondaryText: `${PRICING_PLAN_QUANTITY[PricingPlan.SAVER]} days worth of food every 42 days`,
    tertiaryText: "£1.99/day",
    tag: "Best value",
  },
} as const;

export const MEAL_PLAN_HALF = {
  _uid: PricingPlan.HALF,
  title: formatTitle(PricingPlan.HALF),
  value: PricingPlan.HALF,
  component: "select_option",
  advanced_options: {
    secondaryText: `${PRICING_PLAN_QUANTITY[PricingPlan.HALF]} days worth of food every 56 days`,
    tertiaryText: "£1.05/day",
  },
} as const;

export const MEAL_PLAN_FREEZER = {
  _uid: PricingPlan.FREEZER,
  title: formatTitle(PricingPlan.FREEZER),
  value: PricingPlan.FREEZER,
  component: "select_option",
  advanced_options: {
    secondaryText: `${PRICING_PLAN_QUANTITY[PricingPlan.FREEZER]} days worth of food every 14 days`,
    tertiaryText: "£2.30/day",
  },
} as const;

export const ALL_MEAL_PLANS = [
  MEAL_PLAN_STANDARD,
  MEAL_PLAN_SAVER,
  MEAL_PLAN_HALF,
  // FREEZER is not available for all customers, only for those who have limited freezer space
  // MEAL_PLAN_FREEZER,
];
